import { tidesDataSchema } from "@/schemas/tide-data-schema";
import { ITidesfetchResult } from "@/types/tides-type";

export const fetchTides = async (): Promise<ITidesfetchResult> => {
	try {
		const res = await fetch(
			"https://kuwait.exelys.io/kuwait_tide_times/tides.json",
		);

		if (!res.ok) {
			throw new Error("Failed to fetch");
		}

		const data = await res.json();

		const validatedData = tidesDataSchema.parse(data);

		return {
			isLoading: false,
			tidesData: validatedData,
			error: null,
		};
	} catch {
		return {
			isLoading: false,
			tidesData: [],
			error: "Une erreur est survenue",
		};
	}
};
